import React from 'react';
import CorporateConsultList from '../../../components/consult/list/corporate-list';

export default () => {
  return <CorporateConsultList/>
}